const { DropdownMenu, MenuGroup, MenuItem } = wp.components;
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBolt } from '@fortawesome/free-solid-svg-icons'
import './dropdown.css';
import dynamic from '../../../../../../inc/gutenberg/dynamic/dynamic-tag.json';

const DynamicDropdown = ({ onSelect, dynamicImage = false }) => {
    const filteredDynamic = dynamicImage
        ? Object.keys(dynamic).reduce((acc, groupKey) => {
            const filteredItems = dynamic[groupKey].filter((item) => item.image_url);
            if (filteredItems.length > 0) {
                acc[groupKey] = filteredItems;
            }
            return acc;
        }, {})
        : dynamic;
    return (
        <>
            <DropdownMenu icon={<FontAwesomeIcon icon={faBolt} />} className="softlite-dynamic-dropdown">
                {({ onClose }) => (
                    <>
                        {Object.keys(filteredDynamic).map((groupKey) => (
                            <MenuGroup key={groupKey} label={groupKey}>
                                {filteredDynamic[groupKey].map((item, index) => (
                                    <MenuItem
                                        className="softlite-dynamic-dropdown__item"
                                        key={index}
                                        onClick={() => {
                                            onSelect(item.shortcode);
                                            onClose();
                                        }}
                                    >
                                        {item.name}
                                    </MenuItem>
                                ))}
                            </MenuGroup>
                        ))}
                    </>
                )}
            </DropdownMenu>
        </>
    );
};

export default DynamicDropdown;